export const en = {
    collapse: 'Hide',
    expand: 'Expand'
};
